import { APIGet } from "../../../services/API";

// ----------------------------
// PushPay: Groups
// ----------------------------

export const getPCOGroups = (args) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_GROUPS',
        payload: {
            ui: "loading"
        }
    });

    let url = site + '/api/v1/pco/v2/groups';

    let qs = [];

    if (args.page) qs.push('page=' + args.page);
    if (args.type) qs.push('type=' + args.type);
    if (args.when) qs.push('when=' + args.when);
    if (args.area) qs.push('area=' + args.area);
    if (args.search) qs.push('search=' + args.search)

    let queryString = qs.join('&');

    url += '?' + queryString;

    // Send Request To Get Events
    APIGet(url)
        .then(res => res.json())
        .then(json => {
            dispatch({ type: 'GET_GROUPS_SUCCESS', payload: { ui: "success", groups: json } });
        })
        .catch(e => {
            dispatch({ type: 'GET_GROUPS_ERROR', payload: { ui: "error", message: e } });
        })

}